import { jsx as e, jsxs as t } from "react/jsx-runtime";
import i from "./Accordion.js";
import r from "./Icon.js";
import a from "./Markdown.js";
const l = ({ children: s, isOpen: o }) => /* @__PURE__ */ t("div", { className: "flex gap-4 items-center justify-between px-5 py-4", children: [
  /* @__PURE__ */ e("span", { className: "font-secondary font-semibold", children: s }),
  /* @__PURE__ */ e(r, { className: "text-lg", name: o ? "minus" : "plus", style: "solid" })
] }), n = ({ question: s }) => /* @__PURE__ */ e("li", { children: /* @__PURE__ */ e(i, { heading: /* @__PURE__ */ e(l, { children: s }), children: /* @__PURE__ */ e(a, { className: "px-5 py-4 text-neutral-500", children: n.questions[s] }) }) });
n.questions = {};
export {
  n as default
};
